<div class="showedit001-div" style="top:2%;left: 35%;">
  <div nz-row>
    <div nz-col>
      <div class="editborder111">
        <div nzSpan nzCentered="true" class="editborder">
          <div class="editLabel" style=" width:600px;
          border-bottom: 1px solid #000000 !important;">
            <span style="color: black;">{{"deliveryMaintain"|translate}}</span>
            <em nz-icon [nzType]="'close'" class='close-btn' (click)="onClose()"></em>
          </div>
          <ng-template #contentTemplate>
            <div>
              <p>{{ "question1" | translate }}</p>
              <p>
                {{ "question2" | translate }}
              </p>
            </div>
          </ng-template>
          <!-- <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm($event, validateForm.value)"> -->
          <form nz-form [formGroup]="validateForm" >
            <div style="width: 600px;height: 20px;background-color: rgb(255, 255, 255);">

            </div>
          <div style="background-color: rgb(255, 255, 255);">
            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'table.Company' | translate }}">
                      {{ "table.Company" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16">
                    <input nz-input formControlName="Company" />
                  </nz-form-control>
                </nz-form-item>
              </div>

            </div>

            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'table.PONO' | translate }}">
                        {{ "table.PONO" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16">
                    <input nz-input formControlName="PONO" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>


            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'table.POLN' | translate }}">
                        {{ "table.POLN" | translate}}</span>
                      
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16">
                    <input nz-input formControlName="POLN" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>



            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12" [nzRequired]="Required">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'UserRequiDate2' | translate }}">
                        {{ "UserRequiDate2" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16">
                    <nz-date-picker formControlName="UserDate" [nzFormat]="dateFormat"  [nzDisabledDate]="DisabledBeforeDate"></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12" [nzRequired]="VendorRequired">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'VendorConfirDate2' | translate }}">
                        {{ "VendorConfirDate2" | translate}}</span>
                     
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16">
                    <nz-date-picker formControlName="VendorDate" [nzFormat]="dateFormat" [nzDisabledDate]="DisabledVendorDate"></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'Reason' | translate }}">
                        {{ "Reason" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16" *ngIf="tw">
                    <nz-select formControlName="Reason" nzAllowClear style="width: 100%;">
                      <nz-option *ngFor="let option of ReasonList" [nzLabel]="option.unreason" [nzValue]="option"
                        nzCustomContent>
                        <div [title]="option.unDetailReason">{{option.unreason}}</div>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                  <nz-form-control nzSpan="16" *ngIf="cn">
                    <nz-select formControlName="Reason" nzAllowClear style="width: 100%;">
                      <nz-option *ngFor="let option of ReasonList" [nzLabel]="option.unChreason" [nzValue]="option"
                        nzCustomContent>
                        <div [title]="option.unChDetailReason">{{option.unChreason}}</div>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                  <nz-form-control nzSpan="16" *ngIf="en">
                    <nz-select formControlName="Reason" nzAllowClear style="width: 100%;">
                      <nz-option *ngFor="let option of ReasonList" [nzLabel]="option.unEnreason" [nzValue]="option"
                        nzCustomContent>
                        <div [title]="option.unEnDetailReason">{{option.unEnreason}}</div>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                  <nz-form-control nzSpan="16" *ngIf="vn">
                    <nz-select formControlName="Reason" nzAllowClear style="width: 100%;">
                      <nz-option *ngFor="let option of ReasonList" [nzLabel]="option.unEnreason" [nzValue]="option"
                        nzCustomContent>
                        <div [title]="option.unEnDetailReason">{{option.unEnreason}}</div>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>


            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'Remark' | translate }}">
                        {{ "Remark" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="24">
                    <textarea placeholder="{{'RemarkLimit'|translate}}" formControlName="remark" rows="2" style="width: 230px;"></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'ShipmentDate' | translate }}">
                        {{ "ShipmentDate" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16">
                    <nz-date-picker formControlName="ShipmentDate" [nzFormat]="dateFormat"
                    [nzDisabledDate]="disabledDate"></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'ShipmentFile' | translate }}">
                        {{ "ShipmentFile" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16" *ngIf="ShippingFileName ==null">
                    <nz-upload [nzHeaders]="{ authorization: 'authorization-text' }"
                    (nzChange)="ShipmentHandleChange($event)" [nzBeforeUpload]="ShipmentBeforeUploadFile" [nzFileList]="fileList">
                    <button nz-button  nzType="primary"  class="margin-left-10 default-button">
                      <span nz-icon nzType="upload"></span>
                      {{ "UploadExcel" | translate}}
                    </button>
                  </nz-upload>
                  </nz-form-control>
                  <nz-form-control nzSpan="16" *ngIf="ShippingFileName !=null">
                    <span class="truncate">{{ShippingFileName}}
                    </span>
                    <span nz-icon nzType="delete" nzTheme="twotone" class="icon-hover"
                      (click)="onDeleteShippingFile()"></span>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'ActualDateArrival' | translate }}">
                        {{ "ActualDateArrival" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16">
                    <nz-date-picker formControlName="ActualArrivalDate" [nzFormat]="dateFormat"
                    [nzDisabledDate]="disabledDate"></nz-date-picker>
                  </nz-form-control>
                  <div nz-col >

                    <button  nz-popover [nzPopoverContent]="contentTemplate" style=" border: none;background-color: transparent;"
                    nzPopoverPlacement="rightTop"><span nz-icon nzType="question-circle" nzTheme="twotone" style="font-size: 24px;" ></span>
                   
                  </button>
                  </div>
                </nz-form-item>
              </div>
            </div>


            <div nz-row>
              <div nz-col nzSpan="18">
                <nz-form-item>
                  <nz-form-label nzSpan="12">
                    <div class="width-100-percent label-font">
                      <span class="text-ellipsis" title="{{'DeliveryDate' | translate }}">
                        {{ "DeliveryDate" | translate}}</span>
                    </div>
                  </nz-form-label>
                  <nz-form-control nzSpan="16" *ngIf="vDeliverGoodsFileName ==null">
                    <nz-upload [nzHeaders]="{ authorization: 'authorization-text' }"
                      (nzChange)="ActualArrivalhandleChange($event)" [nzBeforeUpload]="ActualArrivalbeforeUploadFile" [nzFileList]="ActualArrivalfileList">
                      <button nz-button  nzType="primary"  class="margin-left-10 default-button"> 
                        <span nz-icon nzType="upload" ></span>
                        {{ "UploadExcel" | translate}}
                      </button>
                    </nz-upload>
                  </nz-form-control>
                  <nz-form-control nzSpan="16" *ngIf="vDeliverGoodsFileName !=null">
                    <span class="truncate">{{vDeliverGoodsFileName}}</span>
                    <span nz-icon nzType="delete" nzTheme="twotone" class="icon-hover"
                      (click)="onDeleteVDeliverGoodsFile()"></span>

                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="24">
                <div class="editLabel-bottom">

                  <div nz-col nzPush="18" style="margin-top: 10px;">
                    <button nz-button nzType="default" style="height: 34px;" class="without-backgroud-button"
                      (click)="onClose()">{{'Cancel'|translate}}</button>
                    <button nz-button nzType="primary" style="height: 34px;" class="margin-left-10 default-button"
                      (click)="submitForm($event, validateForm.value)">{{'Save'|translate}}</button>
                  </div>
    
                </div>
              </div>
            </div>
          </div>
          </form>
        </div>
      </div>

    </div>
  </div>

</div>